import { Button, ButtonProps } from '@chakra-ui/react'
import { useCurrentUser } from '@src/hooks/useCurrentUser'
import { startups3Url } from '@src/lib/startups-url'
import { ReactNode, useRef, useState } from 'react'

function checkValidExtension({ allowedExtensions, fileToUpload }: any) {
  let isValidExtension = allowedExtensions.indexOf('*') !== -1
  allowedExtensions.forEach(ext => {
    if (fileToUpload.name.endsWith(ext)) {
      isValidExtension = true
    }
  })

  allowedExtensions.forEach(ext => {
    if (fileToUpload.name.endsWith(ext)) {
      isValidExtension = true
    }
  })

  return isValidExtension
}

function checkFileSize({ fileToUpload, maxSizeInBytes }) {
  return fileToUpload.size < maxSizeInBytes
}

type UploadButtonProps = {
  afterSuccess: (url: string, storedFileId?: string) => void
  afterError: (err: any) => void
  allowedExtensions?: string[]
  buttonProps?: ButtonProps
  children?: ReactNode
  maxSizeInBytes?: number
  uploadUrl?: string
  storedFile?: {
    attachmentType?: string
    attachmentId: string
    contextKey?: string
  }
}

export const UploadButton = (props: UploadButtonProps) => {
  const { currentUser } = useCurrentUser()
  const fileInputRef = useRef<HTMLInputElement>(null)
  const [isUploading, setIsUploading] = useState(false)
  const [isSuccessful, setIsSuccessful] = useState(false)

  const allowedExtensions = props.allowedExtensions || ['*']
  const uploadUrl = props.uploadUrl || startups3Url('/assets/upload-document')
  const afterSuccess =
    props.afterSuccess || ((url: string, storedFileId?: string) => console.log(url, afterSuccess))
  const afterError = props.afterError || ((err: any) => console.log(err))
  const maxSizeInBytes = props.maxSizeInBytes || 10000000 // 10 MB default

  async function onFileChange(e) {
    try {
      const fileToUpload = e.target.files[0]

      if (!fileToUpload) {
        return
      }

      if (!checkValidExtension({ allowedExtensions, fileToUpload })) {
        afterError(`Please select one of these file types: ${allowedExtensions.join(', ')}`)
        return
      }

      if (!checkFileSize({ fileToUpload, maxSizeInBytes })) {
        afterError(`Please select a file that is less than ${maxSizeInBytes / 1000000}MB in size`)
        return
      }

      setIsUploading(true)

      const body = new FormData()
      body.append('fileToUpload', fileToUpload)
      body.append('attachmentType', props.storedFile?.attachmentType)
      body.append('attachmentId', props.storedFile?.attachmentId)
      body.append('contextKey', props.storedFile?.contextKey)
      body.append('maxSizeInBytes', `${maxSizeInBytes}`)

      const response = await fetch(uploadUrl, {
        method: 'POST',
        body,
        credentials: 'include',
      })

      setIsUploading(false)

      const data = await response.json()

      if (data.error) {
        fileInputRef.current.value = null
        afterError(data.error)
      }

      if (data.url) {
        setIsSuccessful(true)
        setTimeout(() => setIsSuccessful(false), 2000)
        fileInputRef.current.value = null
        afterSuccess(data.url, data.storedFileId)
      }
    } catch (err) {
      setIsUploading(false)
      setIsSuccessful(false)
      afterError(err)
    }
  }

  return (
    <span>
      <Button
        {...(props.buttonProps || {})}
        loading={isUploading || isSuccessful}
        onClick={ev => {
          ev.preventDefault()
          fileInputRef.current.click()
        }}
      >
        {props.children || 'Upload'}
      </Button>
      <input ref={fileInputRef} style={{ display: 'none' }} type={'file'} onChange={onFileChange} />
    </span>
  )
}
